var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { of as observableOf } from 'rxjs';
import { withLatestFrom, switchMap } from 'rxjs/operators';
import { CategoriesApi, CategoryApi, OrganisationsApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as actions from '../actions/index';
import { getSelectedId } from '../reducers/index';
import * as selectors from '../reducers/index';
var MemoCategoryEffects = /** @class */ (function () {
    function MemoCategoryEffects(store, actions$, adminCategories, api, org) {
        var _this = this;
        this.store = store;
        this.actions$ = actions$;
        this.adminCategories = adminCategories;
        this.api = api;
        this.org = org;
        this.getMemoCategories = this.actions$.ofType(actions.MemoCategories.REQUEST_ALL).pipe(switchMap(function (action) {
            return _this.api
                .find()
                .map(function (res) { return actions.MemoCategories.ResponseSuccessAllAction(res); })
                .catch(function (err) { return observableOf(actions.MemoCategories.ResponseFailAllAction(err)); });
        }));
        this.fetchOrgMemoCategories = this.actions$
            .ofType(actions.MemoCategories.REQUEST_BY_ID).pipe(withLatestFrom(this.store.select(getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], organisationId = _a[1];
            return _this.org
                .getCategory(organisationId)
                .map(function (data) {
                return actions.MemoCategories.ResponseSuccessByIdAction({
                    id: organisationId,
                    data: data
                });
            })
                .catch(function (err) { return observableOf(actions.MemoCategories.ResponseFailByIdAction(err)); });
        }));
        this.removeOrgMemoCategory = this.actions$
            .ofType(actions.MemoCategories.REQUEST_REMOVE_BY_ID).pipe(withLatestFrom(this.store.select(getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], organisationId = _a[1];
            return _this.org
                .deleteCategory(organisationId, action.payload.id)
                .map(function (res) {
                return actions.MemoCategories.ResponseSuccessRemoveById({
                    organisationId: organisationId,
                    categoryId: action.payload.id
                });
            })
                .catch(function (err) { return observableOf(actions.MemoCategories.ResponseFailRemoveById(err)); });
        }));
        this.addOrgMemoCategory = this.actions$
            .ofType(actions.MemoCategories.REQUEST_ADD_BY_ID).pipe(withLatestFrom(this.store.select(getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], organisationId = _a[1];
            return _this.org
                .createCategory(organisationId, action.payload.id, { ordinal: action.payload.ordinal })
                .map(function (res) {
                return actions.MemoCategories.ResponseSuccessAddById({
                    organisationId: organisationId,
                    data: res
                });
            })
                .catch(function (err) { return observableOf(actions.MemoCategories.ResponseFailAddById(err)); });
        }));
        this.saveCategory = this.actions$.ofType(actions.MemoCategories.REQUEST_SAVE).pipe(switchMap(function (action) {
            return _this.adminCategories
                .updateAttributes(action.payload.id, action.payload.data)
                .map(function (res) { return actions.MemoCategories.ResponseSuccessSaveAction(res); })
                .catch(function (err) { return observableOf(actions.MemoCategories.ResponseFailSaveAction(err)); });
        }));
        this.createCategory = this.actions$.ofType(actions.MemoCategories.REQUEST_CREATE).pipe(switchMap(function (action) {
            return _this.adminCategories
                .create(action.payload)
                .map(function (res) { return actions.MemoCategories.ResponseSuccessCreateAction(res); })
                .catch(function (err) { return observableOf(actions.MemoCategories.ResponseFailCreateAction(err)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], MemoCategoryEffects.prototype, "getMemoCategories", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], MemoCategoryEffects.prototype, "fetchOrgMemoCategories", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], MemoCategoryEffects.prototype, "removeOrgMemoCategory", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], MemoCategoryEffects.prototype, "addOrgMemoCategory", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], MemoCategoryEffects.prototype, "saveCategory", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], MemoCategoryEffects.prototype, "createCategory", void 0);
    return MemoCategoryEffects;
}());
export { MemoCategoryEffects };
